import { translateFallbackText } from "./i18nFallbacks";
import { UI_COPY_TRANSLATIONS } from "./i18nCatalog";

export const DEFAULT_LANGUAGE = "pt-BR";
export const UI_LANGUAGE_STORAGE_KEY = "pennypantry_language";
export const LEGACY_UI_LANGUAGE_STORAGE_KEY = "priceradar_language";

const LANGUAGE_LOCALES = {
  "pt-BR": "pt-BR",
  en: "en-US",
  es: "es-ES",
  it: "it-IT",
  fr: "fr-FR",
  de: "de-DE",
  "pt-PT": "pt-PT",
};

export const LANGUAGE_OPTIONS = [
  { code: "pt-BR", label: "Portugues (Brasil)" },
  { code: "en", label: "English" },
  { code: "es", label: "Espanol" },
  { code: "it", label: "Italiano" },
  { code: "fr", label: "Francais" },
  { code: "de", label: "Deutsch" },
  { code: "pt-PT", label: "Portugues (Portugal)" },
];

const SUPPORTED_LANGUAGE_CODES = new Set(LANGUAGE_OPTIONS.map((option) => option.code));

const TRANSLATIONS = {
  "pt-BR": {
    "app.toggle.register": "Criar conta",
    "app.toggle.login": "Ja tenho conta",
    "tab.map": "Mapa",
    "tab.search": "Buscar",
    "tab.list": "Lista",
    "tab.ranking": "Ranking de lojas",
    "tab.market": "Mercado",
    "tab.settings": "Conta",
    "auth.login.title": "Entrar",
    "auth.login.description": "Use sua conta para abrir o mapa e comparar mercados automaticamente.",
    "auth.register.title": "Criar conta",
    "auth.register.description": "Cadastre seu perfil para salvar localizacao, raio padrao e listas inteligentes.",
    "auth.name": "Nome",
    "auth.email": "Email",
    "auth.password": "Senha",
    "auth.login.button": "Entrar",
    "auth.login.loading": "Entrando...",
    "auth.register.button": "Criar conta",
    "auth.register.loading": "Criando...",
    "auth.verification.title": "Confira seu email",
    "auth.verification.open": "Abrir confirmacao de email",
    "auth.verification.resend": "Reenviar confirmacao",
    "auth.verification.resending": "Reenviando...",
    "auth.verification.go_login": "Ir para login",
    "auth.verification.code_placeholder": "Codigo de verificacao",
    "auth.verification.code_required": "Codigo de verificacao obrigatorio.",
    "auth.verification.confirm": "Confirmar codigo",
    "auth.verification.confirming": "Confirmando...",
    "auth.verification.success": "Email confirmado. Agora voce pode entrar.",
    "auth.verification.debug_code": "Codigo de depuracao",
    "auth.verification.debug_link": "Link de depuracao disponivel apenas em ambiente local.",
    "auth.login.email_required": "Email obrigatorio.",
    "auth.login.error": "Nao foi possivel entrar.",
    "auth.register.error": "Nao foi possivel criar sua conta.",
    "auth.verification.resend_error": "Nao foi possivel reenviar o codigo de verificacao.",
    "auth.verification.confirm_error": "Nao foi possivel confirmar este codigo.",
    "search.title": "Procure mercado, categoria, marca ou produto",
    "search.description": "A busca mistura tudo em um campo unico para voce chegar rapido no mercado ou no item certo.",
    "search.placeholder": "Buscar por mercado, farmacia, arroz, marca, categoria...",
    "search.button": "Buscar",
    "search.loading": "Buscando...",
    "search.suggestions": "Sugestoes",
    "search.suggestions.loading": "Buscando recomendacoes...",
    "search.suggestion.market": "Mercado",
    "search.suggestion.product": "Produto",
    "settings.language.label": "Idioma do app",
    "settings.language.help": "Escolha o idioma da interface. Menus, botoes e mensagens acompanham esse idioma.",
  },
  en: {
    "app.toggle.register": "Create account",
    "app.toggle.login": "I already have an account",
    "tab.map": "Map",
    "tab.search": "Search",
    "tab.list": "List",
    "tab.ranking": "Store ranking",
    "tab.market": "Market",
    "tab.settings": "Account",
    "auth.login.title": "Sign in",
    "auth.login.description": "Use your account to open the map and compare markets automatically.",
    "auth.register.title": "Create account",
    "auth.register.description": "Create your profile to save location, default radius and smart lists.",
    "auth.name": "Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.login.button": "Sign in",
    "auth.login.loading": "Signing in...",
    "auth.register.button": "Create account",
    "auth.register.loading": "Creating...",
    "auth.verification.title": "Check your email",
    "auth.verification.open": "Open verification link",
    "auth.verification.resend": "Resend verification",
    "auth.verification.resending": "Resending...",
    "auth.verification.go_login": "Go to login",
    "auth.verification.code_placeholder": "Verification code",
    "auth.verification.code_required": "Verification code is required.",
    "auth.verification.confirm": "Confirm code",
    "auth.verification.confirming": "Confirming...",
    "auth.verification.success": "Email verified. You can sign in now.",
    "auth.verification.debug_code": "Debug code",
    "auth.verification.debug_link": "Debug link available only in the local environment.",
    "auth.login.email_required": "Email is required.",
    "auth.login.error": "Could not sign in.",
    "auth.register.error": "Could not create your account.",
    "auth.verification.resend_error": "Could not resend the verification code.",
    "auth.verification.confirm_error": "Could not verify this code.",
    "search.title": "Search for market, category, brand or product",
    "search.description": "Search mixes everything in one field so you can reach the right market or item faster.",
    "search.placeholder": "Search by market, pharmacy, rice, brand, category...",
    "search.button": "Search",
    "search.loading": "Searching...",
    "search.suggestions": "Suggestions",
    "search.suggestions.loading": "Loading suggestions...",
    "search.suggestion.market": "Market",
    "search.suggestion.product": "Product",
    "settings.language.label": "App language",
    "settings.language.help": "Choose the interface language. Menus, buttons and messages follow this selection.",
  },
  es: {
    "app.toggle.register": "Crear cuenta",
    "app.toggle.login": "Ya tengo cuenta",
    "tab.map": "Mapa",
    "tab.search": "Buscar",
    "tab.list": "Lista",
    "tab.ranking": "Ranking de tiendas",
    "tab.market": "Mercado",
    "tab.settings": "Cuenta",
    "auth.login.title": "Entrar",
    "auth.login.description": "Usa tu cuenta para abrir el mapa y comparar mercados automaticamente.",
    "auth.register.title": "Crear cuenta",
    "auth.register.description": "Crea tu perfil para guardar ubicacion, radio por defecto y listas inteligentes.",
    "auth.name": "Nombre",
    "auth.email": "Correo",
    "auth.password": "Contrasena",
    "auth.login.button": "Entrar",
    "auth.login.loading": "Entrando...",
    "auth.register.button": "Crear cuenta",
    "auth.register.loading": "Creando...",
    "auth.verification.title": "Revisa tu correo",
    "auth.verification.open": "Abrir enlace de verificacion",
    "auth.verification.resend": "Reenviar verificacion",
    "auth.verification.resending": "Reenviando...",
    "auth.verification.go_login": "Ir al login",
    "search.title": "Busca mercado, categoria, marca o producto",
    "search.description": "La busqueda mezcla todo en un solo campo para llegar mas rapido al mercado o producto correcto.",
    "search.placeholder": "Buscar por mercado, farmacia, arroz, marca, categoria...",
    "search.button": "Buscar",
    "search.loading": "Buscando...",
    "search.suggestions": "Sugerencias",
    "search.suggestions.loading": "Buscando sugerencias...",
    "search.suggestion.market": "Mercado",
    "search.suggestion.product": "Producto",
    "settings.language.label": "Idioma de la app",
    "settings.language.help": "Elige el idioma de la interfaz. Menus, botones y mensajes siguen esta seleccion.",
  },
  it: {
    "app.toggle.register": "Crea account",
    "app.toggle.login": "Ho gia un account",
    "tab.map": "Mappa",
    "tab.search": "Cerca",
    "tab.list": "Lista",
    "tab.ranking": "Classifica negozi",
    "tab.market": "Mercato",
    "tab.settings": "Account",
    "auth.login.title": "Accedi",
    "auth.login.description": "Usa il tuo account per aprire la mappa e confrontare i mercati automaticamente.",
    "auth.register.title": "Crea account",
    "auth.register.description": "Crea il tuo profilo per salvare posizione, raggio predefinito e liste smart.",
    "auth.name": "Nome",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.login.button": "Accedi",
    "auth.login.loading": "Accesso...",
    "auth.register.button": "Crea account",
    "auth.register.loading": "Creazione...",
    "auth.verification.title": "Controlla la tua email",
    "auth.verification.open": "Apri link di verifica",
    "auth.verification.resend": "Invia di nuovo",
    "auth.verification.resending": "Invio...",
    "auth.verification.go_login": "Vai al login",
    "search.title": "Cerca mercato, categoria, marca o prodotto",
    "search.description": "La ricerca unisce tutto in un solo campo per trovare piu velocemente il mercato o il prodotto giusto.",
    "search.placeholder": "Cerca per mercato, farmacia, riso, marca, categoria...",
    "search.button": "Cerca",
    "search.loading": "Ricerca...",
    "search.suggestions": "Suggerimenti",
    "search.suggestions.loading": "Ricerca suggerimenti...",
    "search.suggestion.market": "Mercato",
    "search.suggestion.product": "Prodotto",
    "settings.language.label": "Lingua dell'app",
    "settings.language.help": "Scegli la lingua dell'interfaccia. Menu, pulsanti e messaggi seguono questa scelta.",
  },
  fr: {
    "app.toggle.register": "Creer un compte",
    "app.toggle.login": "J'ai deja un compte",
    "tab.map": "Carte",
    "tab.search": "Recherche",
    "tab.list": "Liste",
    "tab.ranking": "Classement magasins",
    "tab.market": "Magasin",
    "tab.settings": "Compte",
    "auth.login.title": "Connexion",
    "auth.login.description": "Utilisez votre compte pour ouvrir la carte et comparer les magasins automatiquement.",
    "auth.register.title": "Creer un compte",
    "auth.register.description": "Creez votre profil pour enregistrer la position, le rayon par defaut et les listes intelligentes.",
    "auth.name": "Nom",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.login.button": "Connexion",
    "auth.login.loading": "Connexion...",
    "auth.register.button": "Creer un compte",
    "auth.register.loading": "Creation...",
    "auth.verification.title": "Verifiez votre email",
    "auth.verification.open": "Ouvrir le lien de verification",
    "auth.verification.resend": "Renvoyer la verification",
    "auth.verification.resending": "Renvoi...",
    "auth.verification.go_login": "Aller au login",
    "search.title": "Recherchez magasin, categorie, marque ou produit",
    "search.description": "La recherche melange tout dans un seul champ pour trouver plus vite le bon magasin ou produit.",
    "search.placeholder": "Rechercher par magasin, pharmacie, riz, marque, categorie...",
    "search.button": "Rechercher",
    "search.loading": "Recherche...",
    "search.suggestions": "Suggestions",
    "search.suggestions.loading": "Chargement des suggestions...",
    "search.suggestion.market": "Magasin",
    "search.suggestion.product": "Produit",
    "settings.language.label": "Langue de l'app",
    "settings.language.help": "Choisissez la langue de l'interface. Menus, boutons et messages suivent ce choix.",
  },
  de: {
    "app.toggle.register": "Konto erstellen",
    "app.toggle.login": "Ich habe schon ein Konto",
    "tab.map": "Karte",
    "tab.search": "Suche",
    "tab.list": "Liste",
    "tab.ranking": "Ladenranking",
    "tab.market": "Markt",
    "tab.settings": "Konto",
    "auth.login.title": "Anmelden",
    "auth.login.description": "Nutze dein Konto, um die Karte zu offnen und Markte automatisch zu vergleichen.",
    "auth.register.title": "Konto erstellen",
    "auth.register.description": "Erstelle dein Profil, um Standort, Standardradius und intelligente Listen zu speichern.",
    "auth.name": "Name",
    "auth.email": "E-Mail",
    "auth.password": "Passwort",
    "auth.login.button": "Anmelden",
    "auth.login.loading": "Anmeldung...",
    "auth.register.button": "Konto erstellen",
    "auth.register.loading": "Erstellen...",
    "auth.verification.title": "Prufe deine E-Mail",
    "auth.verification.open": "Bestatigungslink offnen",
    "auth.verification.resend": "Bestatigung erneut senden",
    "auth.verification.resending": "Erneut senden...",
    "auth.verification.go_login": "Zum Login",
    "search.title": "Suche nach Markt, Kategorie, Marke oder Produkt",
    "search.description": "Die Suche mischt alles in einem Feld, damit du schneller zum richtigen Markt oder Produkt kommst.",
    "search.placeholder": "Suche nach Markt, Apotheke, Reis, Marke, Kategorie...",
    "search.button": "Suchen",
    "search.loading": "Suche...",
    "search.suggestions": "Empfehlungen",
    "search.suggestions.loading": "Empfehlungen werden geladen...",
    "search.suggestion.market": "Markt",
    "search.suggestion.product": "Produkt",
    "settings.language.label": "App-Sprache",
    "settings.language.help": "Wahle die Sprache der Oberflache. Menus, Schaltflachen und Meldungen folgen dieser Auswahl.",
  },
  "pt-PT": {
    "app.toggle.register": "Criar conta",
    "app.toggle.login": "Ja tenho conta",
    "tab.map": "Mapa",
    "tab.search": "Pesquisar",
    "tab.list": "Lista",
    "tab.ranking": "Ranking de lojas",
    "tab.market": "Mercado",
    "tab.settings": "Conta",
    "auth.login.title": "Entrar",
    "auth.login.description": "Use a sua conta para abrir o mapa e comparar mercados automaticamente.",
    "auth.register.title": "Criar conta",
    "auth.register.description": "Crie o seu perfil para guardar localizacao, raio predefinido e listas inteligentes.",
    "auth.name": "Nome",
    "auth.email": "Email",
    "auth.password": "Palavra-passe",
    "auth.login.button": "Entrar",
    "auth.login.loading": "A entrar...",
    "auth.register.button": "Criar conta",
    "auth.register.loading": "A criar...",
    "auth.verification.title": "Verifique o seu email",
    "auth.verification.open": "Abrir ligacao de verificacao",
    "auth.verification.resend": "Reenviar verificacao",
    "auth.verification.resending": "A reenviar...",
    "auth.verification.go_login": "Ir para login",
    "search.title": "Pesquise mercado, categoria, marca ou produto",
    "search.description": "A pesquisa mistura tudo num unico campo para chegar mais depressa ao mercado ou produto certo.",
    "search.placeholder": "Pesquisar por mercado, farmacia, arroz, marca, categoria...",
    "search.button": "Pesquisar",
    "search.loading": "A pesquisar...",
    "search.suggestions": "Sugestoes",
    "search.suggestions.loading": "A procurar sugestoes...",
    "search.suggestion.market": "Mercado",
    "search.suggestion.product": "Produto",
    "settings.language.label": "Idioma da app",
    "settings.language.help": "Escolha o idioma da interface. Menus, botoes e mensagens acompanham essa escolha.",
  },
};

const EXTRA_TRANSLATIONS = {
  "pt-BR": {
    "app.name": "PennyPantry",
    "app.nav.primary": "Navegacao principal",
    "auth.brand.title": "Economia em compras com mapa e inteligencia de rota",
    "auth.brand.description":
      "Compare mercados reais perto de voce, monte listas inteligentes e acompanhe catalogos atualizados em um fluxo feito para celular.",
    "common.no_data": "n/d",
    "common.current_account": "Conta atual",
    "common.user": "Usuario",
    "common.visible_markets": "mercados visiveis no app",
    "common.coverage": "Cobertura",
    "common.base": "Base",
    "common.active_base_ready": "Base ativa pronta para recomendacoes",
    "common.favorite": "Favoritar",
    "common.remove_favorite": "Remover favorito",
    "common.add_product": "Add produto",
    "map.component.loading": "Carregando mapa...",
    "map.component.tap_to_use": "Toque para usar este mercado automaticamente.",
    "map.component.cluster": "{{count}} locais",
    "map.component.your_location": "Sua localizacao",
    "chart.need_more": "Adicione mais leituras para o grafico ganhar forma.",
    "chart.title": "Linha de inflacao",
    "chart.readings": "{{count}} leituras",
    "upload.not_logged_in": "Voce nao esta logado.",
    "upload.error": "Erro ao enviar imagem.",
    "upload.process": "Processando...",
    "upload.send": "Enviar imagem",
    "upload.extracting": "Extraindo texto da imagem...",
  },
  en: {
    "app.name": "PennyPantry",
    "app.nav.primary": "Primary navigation",
    "auth.brand.title": "Shopping savings with maps and route intelligence",
    "auth.brand.description":
      "Compare real nearby markets, build smart lists and follow updated catalogs in a mobile-first flow.",
    "dashboard.hero.title": "See the fastest path to cheaper groceries",
    "dashboard.hero.description":
      "Start on the map, update your location and focus only on nearby markets with the best chances to save today. Active radius: {{radius}} miles.",
    "dashboard.hero.account": "Current account",
    "dashboard.hero.user": "User",
    "dashboard.hero.coverage": "Coverage: {{miles}} mi (~{{km}} km)",
    "dashboard.hero.base_ready": "Location ready for live recommendations",
    "common.no_data": "n/a",
    "common.current_account": "Current account",
    "common.user": "User",
    "common.visible_markets": "visible markets in the app",
    "common.coverage": "Coverage",
    "common.base": "Base",
    "common.active_base_ready": "Active base ready for recommendations",
    "common.favorite": "Favorite",
    "common.remove_favorite": "Remove favorite",
    "common.add_product": "Add product",
    "map.component.loading": "Loading map...",
    "map.component.tap_to_use": "Tap to use this market automatically.",
    "map.component.cluster": "{{count}} places",
    "map.component.your_location": "Your location",
    "chart.need_more": "Add more readings for the chart to take shape.",
    "chart.title": "Inflation line",
    "chart.readings": "{{count}} readings",
    "upload.not_logged_in": "You are not logged in.",
    "upload.error": "Error uploading image.",
    "upload.process": "Processing...",
    "upload.send": "Send image",
    "upload.extracting": "Extracting text from image...",
  },
};

const STATUS_TRANSLATIONS = {
  "pt-BR": {
    "auth.register.language_label": "Idioma do app",
    "dashboard.hero.coverage": "Raio ativo: {{radius}}",
    "ranking.status.updated": "Ranking de mercados atualizado.",
    "status.market.open.distance": "{{market}} aberto pelo ranking de distancia.",
    "status.market.open.ready": "{{market}} aberto pela lista de lojas prontas.",
    "status.market.open.ranking": "{{market}} aberto pelo ranking de lojas.",
    "status.market.open.list": "{{market}} aberto pela lista inteligente.",
    "status.market.open.search": "{{market}} aberto pela busca.",
    "status.market.open.product_page": "{{market}} aberto pela pagina do produto.",
    "status.market.open.search_suggestion": "{{market}} aberto pelas sugestoes da busca.",
    "search.status.product_opened": "Pagina do produto {{product}} aberta.",
    "search.status.type_product": "Digite um produto para comparar.",
    "search.status.results_found": "{{count}} resultados encontrados para {{product}}.",
    "list.status.calculated": "Lista de compras calculada com sucesso.",
    "list.status.compared": "Comparativo de mercados atualizado.",
    "list.status.route": "Rota economica calculada.",
  },
  en: {
    "auth.register.language_label": "App language",
    "dashboard.hero.coverage": "Active radius: {{radius}}",
    "ranking.status.updated": "Market ranking updated.",
    "status.market.open.distance": "{{market}} opened from the distance ranking.",
    "status.market.open.ready": "{{market}} opened from the ready stores list.",
    "status.market.open.ranking": "{{market}} opened from the store ranking.",
    "status.market.open.list": "{{market}} opened from the smart list.",
    "status.market.open.search": "{{market}} opened from search.",
    "status.market.open.product_page": "{{market}} opened from the product page.",
    "status.market.open.search_suggestion": "{{market}} opened from search suggestions.",
    "search.status.product_opened": "Product page for {{product}} opened.",
    "search.status.type_product": "Type a product to compare.",
    "search.status.results_found": "{{count}} results found for {{product}}.",
    "list.status.calculated": "Shopping list calculated successfully.",
    "list.status.compared": "Market comparison updated.",
    "list.status.route": "Savings route calculated.",
  },
  es: {
    "auth.register.language_label": "Idioma de la app",
    "dashboard.hero.coverage": "Radio activo: {{radius}}",
    "ranking.status.updated": "Ranking de mercados actualizado.",
    "status.market.open.distance": "{{market}} abierto desde el ranking de distancia.",
    "status.market.open.ready": "{{market}} abierto desde la lista de tiendas listas.",
    "status.market.open.ranking": "{{market}} abierto desde el ranking de tiendas.",
    "status.market.open.list": "{{market}} abierto desde la lista inteligente.",
    "status.market.open.search": "{{market}} abierto desde la busqueda.",
    "status.market.open.product_page": "{{market}} abierto desde la pagina del producto.",
    "status.market.open.search_suggestion": "{{market}} abierto desde las sugerencias de busqueda.",
    "search.status.product_opened": "Pagina del producto {{product}} abierta.",
    "search.status.type_product": "Escribe un producto para comparar.",
    "search.status.results_found": "{{count}} resultados encontrados para {{product}}.",
    "list.status.calculated": "Lista de compra calculada con exito.",
    "list.status.compared": "Comparacion de mercados actualizada.",
    "list.status.route": "Ruta de ahorro calculada.",
  },
  it: {
    "auth.register.language_label": "Lingua dell'app",
    "dashboard.hero.coverage": "Raggio attivo: {{radius}}",
    "ranking.status.updated": "Classifica dei mercati aggiornata.",
    "status.market.open.distance": "{{market}} aperto dalla classifica distanza.",
    "status.market.open.ready": "{{market}} aperto dalla lista dei negozi pronti.",
    "status.market.open.ranking": "{{market}} aperto dalla classifica dei negozi.",
    "status.market.open.list": "{{market}} aperto dalla lista intelligente.",
    "status.market.open.search": "{{market}} aperto dalla ricerca.",
    "status.market.open.product_page": "{{market}} aperto dalla pagina prodotto.",
    "status.market.open.search_suggestion": "{{market}} aperto dai suggerimenti di ricerca.",
    "search.status.product_opened": "Pagina prodotto di {{product}} aperta.",
    "search.status.type_product": "Digita un prodotto da confrontare.",
    "search.status.results_found": "{{count}} risultati trovati per {{product}}.",
    "list.status.calculated": "Lista della spesa calcolata con successo.",
    "list.status.compared": "Confronto dei mercati aggiornato.",
    "list.status.route": "Percorso di risparmio calcolato.",
  },
  fr: {
    "auth.register.language_label": "Langue de l'app",
    "dashboard.hero.coverage": "Rayon actif : {{radius}}",
    "ranking.status.updated": "Classement des magasins mis a jour.",
    "status.market.open.distance": "{{market}} ouvert depuis le classement distance.",
    "status.market.open.ready": "{{market}} ouvert depuis la liste des magasins prets.",
    "status.market.open.ranking": "{{market}} ouvert depuis le classement des magasins.",
    "status.market.open.list": "{{market}} ouvert depuis la liste intelligente.",
    "status.market.open.search": "{{market}} ouvert depuis la recherche.",
    "status.market.open.product_page": "{{market}} ouvert depuis la page produit.",
    "status.market.open.search_suggestion": "{{market}} ouvert depuis les suggestions de recherche.",
    "search.status.product_opened": "Page produit de {{product}} ouverte.",
    "search.status.type_product": "Saisissez un produit a comparer.",
    "search.status.results_found": "{{count}} resultats trouves pour {{product}}.",
    "list.status.calculated": "Liste de courses calculee avec succes.",
    "list.status.compared": "Comparaison des magasins mise a jour.",
    "list.status.route": "Itineraire d'economies calcule.",
  },
  de: {
    "auth.register.language_label": "App-Sprache",
    "dashboard.hero.coverage": "Aktiver Radius: {{radius}}",
    "ranking.status.updated": "Marktranking aktualisiert.",
    "status.market.open.distance": "{{market}} aus dem Entfernungsranking geoffnet.",
    "status.market.open.ready": "{{market}} aus der Liste bereiter Laden geoffnet.",
    "status.market.open.ranking": "{{market}} aus dem Ladenranking geoffnet.",
    "status.market.open.list": "{{market}} aus der smarten Liste geoffnet.",
    "status.market.open.search": "{{market}} aus der Suche geoffnet.",
    "status.market.open.product_page": "{{market}} von der Produktseite geoffnet.",
    "status.market.open.search_suggestion": "{{market}} aus den Suchvorschlagen geoffnet.",
    "search.status.product_opened": "Produktseite fur {{product}} geoffnet.",
    "search.status.type_product": "Gib ein Produkt zum Vergleichen ein.",
    "search.status.results_found": "{{count}} Ergebnisse fur {{product}} gefunden.",
    "list.status.calculated": "Einkaufsliste erfolgreich berechnet.",
    "list.status.compared": "Marktvergleich aktualisiert.",
    "list.status.route": "Sparroute berechnet.",
  },
  "pt-PT": {
    "auth.register.language_label": "Idioma da app",
    "dashboard.hero.coverage": "Raio ativo: {{radius}}",
    "ranking.status.updated": "Ranking de mercados atualizado.",
    "status.market.open.distance": "{{market}} aberto pelo ranking de distancia.",
    "status.market.open.ready": "{{market}} aberto pela lista de lojas prontas.",
    "status.market.open.ranking": "{{market}} aberto pelo ranking de lojas.",
    "status.market.open.list": "{{market}} aberto pela lista inteligente.",
    "status.market.open.search": "{{market}} aberto pela pesquisa.",
    "status.market.open.product_page": "{{market}} aberto pela pagina do produto.",
    "status.market.open.search_suggestion": "{{market}} aberto pelas sugestoes da pesquisa.",
    "search.status.product_opened": "Pagina do produto {{product}} aberta.",
    "search.status.type_product": "Escreva um produto para comparar.",
    "search.status.results_found": "{{count}} resultados encontrados para {{product}}.",
    "list.status.calculated": "Lista de compras calculada com sucesso.",
    "list.status.compared": "Comparacao de mercados atualizada.",
    "list.status.route": "Rota de poupanca calculada.",
  },
};

const PRODUCT_UI_TRANSLATIONS = {
  "pt-BR": {
    "nav.open": "Abrir menu",
    "nav.close": "Fechar menu",
    "nav.menu": "Menu",
    "topbar.search.title": "Buscar promocoes",
    "topbar.search.subtitle": "produto, mercado ou oferta",
    "topbar.metrics": "Indicadores da conta",
    "topbar.score": "Nota",
    "topbar.wallet": "Saldo",
    "topbar.reputation": "Reputacao",
    "topbar.reputation.initial": "Inicial",
    "dashboard.hero.base_empty": "Defina uma localizacao",
    "settings.addresses.default_label": "Casa",
    "ranking.hero.eyebrow": "Ranking de lojas",
    "ranking.hero.title": "Todos os rankings em um lugar",
    "ranking.hero.description":
      "Compare lojas por distancia, prontidao para abrir e indice medio de preco sem poluir o mapa inicial.",
    "ranking.hero.refresh": "Atualizar rankings",
    "ranking.distance.eyebrow": "Distancia",
    "ranking.distance.title": "Ranking por distancia",
    "ranking.distance.description":
      "Mostra primeiro as lojas mais perto da localizacao ou endereco ativo.",
    "ranking.distance.empty": "Ative a localizacao para gerar o ranking por distancia.",
    "ranking.ready.eyebrow": "Lojas prontas",
    "ranking.ready.title": "Lojas prontas para abrir",
    "ranking.ready.description":
      "Atalho para abrir lojas ja carregadas no mapa e ver o catalogo mais recente de cada uma.",
    "ranking.ready.store": "loja",
    "ranking.ready.empty": "Carregue o mapa para ver lojas prontas para abrir.",
    "ranking.common.address_missing": "Endereco ainda nao informado",
    "ranking.price.eyebrow": "Preco",
    "ranking.price.title": "Melhor indice medio de preco",
    "ranking.price.description":
      "Ranking calculado com os precos disponiveis, historico e volume de atualizacoes.",
    "ranking.price.index": "indice",
    "ranking.price.average": "Media",
    "ranking.price.meta": "Produtos: {{count}} | atualiz.: {{contributions}}",
    "ranking.price.empty": "Ainda nao ha ranking de preco disponivel.",
  },
  en: {
    "nav.open": "Open menu",
    "nav.close": "Close menu",
    "nav.menu": "Menu",
    "topbar.search.title": "Find deals",
    "topbar.search.subtitle": "product, market or offer",
    "topbar.metrics": "Account indicators",
    "topbar.score": "Score",
    "topbar.wallet": "Balance",
    "topbar.reputation": "Reputation",
    "topbar.reputation.initial": "Initial",
    "dashboard.hero.base_empty": "Set a location",
    "settings.addresses.default_label": "Home",
    "ranking.hero.eyebrow": "Store ranking",
    "ranking.hero.title": "All rankings in one place",
    "ranking.hero.description":
      "Compare stores by distance, readiness and average price index without cluttering the home map.",
    "ranking.hero.refresh": "Refresh rankings",
    "ranking.distance.eyebrow": "Distance",
    "ranking.distance.title": "Distance ranking",
    "ranking.distance.description":
      "Shows stores closest to your active location or address first.",
    "ranking.distance.empty": "Enable location to generate the distance ranking.",
    "ranking.ready.eyebrow": "Ready stores",
    "ranking.ready.title": "Stores ready to open",
    "ranking.ready.description":
      "Shortcut to open stores already loaded on the map and view each latest catalog.",
    "ranking.ready.store": "store",
    "ranking.ready.empty": "Load the map to see stores ready to open.",
    "ranking.common.address_missing": "Address not provided yet",
    "ranking.price.eyebrow": "Price",
    "ranking.price.title": "Best average price index",
    "ranking.price.description":
      "Ranking calculated from available prices, history and update volume.",
    "ranking.price.index": "index",
    "ranking.price.average": "Average",
    "ranking.price.meta": "Products: {{count}} | updates: {{contributions}}",
    "ranking.price.empty": "No price ranking available yet.",
  },
  es: {
    "nav.open": "Abrir menu",
    "nav.close": "Cerrar menu",
    "nav.menu": "Menu",
    "topbar.search.title": "Buscar ofertas",
    "topbar.search.subtitle": "producto, mercado u oferta",
    "topbar.metrics": "Indicadores de la cuenta",
    "topbar.score": "Nota",
    "topbar.wallet": "Saldo",
    "topbar.reputation": "Reputacion",
    "topbar.reputation.initial": "Inicial",
    "dashboard.hero.base_empty": "Define una ubicacion",
    "settings.addresses.default_label": "Casa",
    "ranking.hero.eyebrow": "Ranking de tiendas",
    "ranking.hero.title": "Todos los rankings en un solo lugar",
    "ranking.hero.description":
      "Compara tiendas por distancia, disponibilidad e indice medio de precio sin llenar el mapa inicial.",
    "ranking.hero.refresh": "Actualizar rankings",
    "ranking.distance.eyebrow": "Distancia",
    "ranking.distance.title": "Ranking por distancia",
    "ranking.distance.description":
      "Muestra primero las tiendas mas cercanas a la ubicacion o direccion activa.",
    "ranking.distance.empty": "Activa la ubicacion para generar el ranking por distancia.",
    "ranking.ready.eyebrow": "Tiendas listas",
    "ranking.ready.title": "Tiendas listas para abrir",
    "ranking.ready.description":
      "Atajo para abrir tiendas ya cargadas en el mapa y ver el catalogo mas reciente de cada una.",
    "ranking.ready.store": "tienda",
    "ranking.ready.empty": "Carga el mapa para ver tiendas listas para abrir.",
    "ranking.common.address_missing": "Direccion aun no informada",
    "ranking.price.eyebrow": "Precio",
    "ranking.price.title": "Mejor indice medio de precio",
    "ranking.price.description":
      "Ranking calculado con precios disponibles, historial y volumen de actualizaciones.",
    "ranking.price.index": "indice",
    "ranking.price.average": "Media",
    "ranking.price.meta": "Productos: {{count}} | act.: {{contributions}}",
    "ranking.price.empty": "Aun no hay ranking de precio disponible.",
  },
  it: {
    "nav.open": "Apri menu",
    "nav.close": "Chiudi menu",
    "nav.menu": "Menu",
    "topbar.search.title": "Cerca offerte",
    "topbar.search.subtitle": "prodotto, mercato o offerta",
    "topbar.metrics": "Indicatori account",
    "topbar.score": "Punteggio",
    "topbar.wallet": "Saldo",
    "topbar.reputation": "Reputazione",
    "topbar.reputation.initial": "Iniziale",
    "dashboard.hero.base_empty": "Imposta una posizione",
    "settings.addresses.default_label": "Casa",
    "ranking.hero.eyebrow": "Classifica negozi",
    "ranking.hero.title": "Tutte le classifiche in un posto",
    "ranking.hero.description":
      "Confronta negozi per distanza, disponibilita e indice prezzo medio senza riempire la mappa iniziale.",
    "ranking.hero.refresh": "Aggiorna classifiche",
    "ranking.distance.eyebrow": "Distanza",
    "ranking.distance.title": "Classifica per distanza",
    "ranking.distance.description":
      "Mostra prima i negozi piu vicini alla posizione o indirizzo attivo.",
    "ranking.distance.empty": "Attiva la posizione per generare la classifica per distanza.",
    "ranking.ready.eyebrow": "Negozi pronti",
    "ranking.ready.title": "Negozi pronti da aprire",
    "ranking.ready.description":
      "Scorciatoia per aprire negozi gia caricati sulla mappa e vedere il catalogo piu recente di ciascuno.",
    "ranking.ready.store": "negozio",
    "ranking.ready.empty": "Carica la mappa per vedere i negozi pronti da aprire.",
    "ranking.common.address_missing": "Indirizzo non ancora informato",
    "ranking.price.eyebrow": "Prezzo",
    "ranking.price.title": "Miglior indice prezzo medio",
    "ranking.price.description":
      "Classifica calcolata da prezzi disponibili, cronologia e volume aggiornamenti.",
    "ranking.price.index": "indice",
    "ranking.price.average": "Media",
    "ranking.price.meta": "Prodotti: {{count}} | agg.: {{contributions}}",
    "ranking.price.empty": "Nessuna classifica prezzo disponibile.",
  },
  fr: {
    "nav.open": "Ouvrir le menu",
    "nav.close": "Fermer le menu",
    "nav.menu": "Menu",
    "topbar.search.title": "Chercher promos",
    "topbar.search.subtitle": "produit, magasin ou offre",
    "topbar.metrics": "Indicateurs du compte",
    "topbar.score": "Score",
    "topbar.wallet": "Solde",
    "topbar.reputation": "Reputation",
    "topbar.reputation.initial": "Initial",
    "dashboard.hero.base_empty": "Definir une position",
    "settings.addresses.default_label": "Maison",
    "ranking.hero.eyebrow": "Classement magasins",
    "ranking.hero.title": "Tous les classements au meme endroit",
    "ranking.hero.description":
      "Comparez les magasins par distance, disponibilite et indice moyen de prix sans encombrer la carte d'accueil.",
    "ranking.hero.refresh": "Actualiser les classements",
    "ranking.distance.eyebrow": "Distance",
    "ranking.distance.title": "Classement par distance",
    "ranking.distance.description":
      "Affiche d'abord les magasins les plus proches de la position ou adresse active.",
    "ranking.distance.empty": "Activez la position pour generer le classement par distance.",
    "ranking.ready.eyebrow": "Magasins prets",
    "ranking.ready.title": "Magasins prets a ouvrir",
    "ranking.ready.description":
      "Raccourci pour ouvrir les magasins deja charges sur la carte et voir leur catalogue le plus recent.",
    "ranking.ready.store": "magasin",
    "ranking.ready.empty": "Chargez la carte pour voir les magasins prets a ouvrir.",
    "ranking.common.address_missing": "Adresse pas encore indiquee",
    "ranking.price.eyebrow": "Prix",
    "ranking.price.title": "Meilleur indice moyen de prix",
    "ranking.price.description":
      "Classement calcule avec les prix disponibles, l'historique et le volume de mises a jour.",
    "ranking.price.index": "indice",
    "ranking.price.average": "Moyenne",
    "ranking.price.meta": "Produits : {{count}} | maj : {{contributions}}",
    "ranking.price.empty": "Aucun classement de prix disponible.",
  },
  de: {
    "nav.open": "Menu offnen",
    "nav.close": "Menu schliessen",
    "nav.menu": "Menu",
    "topbar.search.title": "Deals suchen",
    "topbar.search.subtitle": "Produkt, Markt oder Angebot",
    "topbar.metrics": "Kontoindikatoren",
    "topbar.score": "Score",
    "topbar.wallet": "Saldo",
    "topbar.reputation": "Reputation",
    "topbar.reputation.initial": "Start",
    "dashboard.hero.base_empty": "Standort festlegen",
    "settings.addresses.default_label": "Zuhause",
    "ranking.hero.eyebrow": "Ladenranking",
    "ranking.hero.title": "Alle Rankings an einem Ort",
    "ranking.hero.description":
      "Vergleiche Laden nach Entfernung, Bereitschaft und durchschnittlichem Preisindex, ohne die Startkarte zu uberladen.",
    "ranking.hero.refresh": "Rankings aktualisieren",
    "ranking.distance.eyebrow": "Entfernung",
    "ranking.distance.title": "Ranking nach Entfernung",
    "ranking.distance.description":
      "Zeigt zuerst die Laden nahe deinem aktiven Standort oder deiner Adresse.",
    "ranking.distance.empty": "Aktiviere den Standort, um das Entfernungsranking zu erzeugen.",
    "ranking.ready.eyebrow": "Bereite Laden",
    "ranking.ready.title": "Laden bereit zum Offnen",
    "ranking.ready.description":
      "Schnellzugriff auf bereits geladene Laden, um deren neuesten Katalog zu offnen.",
    "ranking.ready.store": "Laden",
    "ranking.ready.empty": "Lade die Karte, um bereite Laden zu sehen.",
    "ranking.common.address_missing": "Adresse noch nicht angegeben",
    "ranking.price.eyebrow": "Preis",
    "ranking.price.title": "Bester durchschnittlicher Preisindex",
    "ranking.price.description":
      "Ranking berechnet aus verfugbaren Preisen, Verlauf und Update-Volumen.",
    "ranking.price.index": "Index",
    "ranking.price.average": "Durchschnitt",
    "ranking.price.meta": "Produkte: {{count}} | Updates: {{contributions}}",
    "ranking.price.empty": "Noch kein Preisranking verfugbar.",
  },
  "pt-PT": {
    "nav.open": "Abrir menu",
    "nav.close": "Fechar menu",
    "nav.menu": "Menu",
    "topbar.search.title": "Pesquisar promocoes",
    "topbar.search.subtitle": "produto, mercado ou oferta",
    "topbar.metrics": "Indicadores da conta",
    "topbar.score": "Nota",
    "topbar.wallet": "Saldo",
    "topbar.reputation": "Reputacao",
    "topbar.reputation.initial": "Inicial",
    "dashboard.hero.base_empty": "Defina uma localizacao",
    "settings.addresses.default_label": "Casa",
    "ranking.hero.eyebrow": "Ranking de lojas",
    "ranking.hero.title": "Todos os rankings num so lugar",
    "ranking.hero.description":
      "Compare lojas por distancia, prontidao e indice medio de preco sem poluir o mapa inicial.",
    "ranking.hero.refresh": "Atualizar rankings",
    "ranking.distance.eyebrow": "Distancia",
    "ranking.distance.title": "Ranking por distancia",
    "ranking.distance.description":
      "Mostra primeiro as lojas mais perto da localizacao ou morada ativa.",
    "ranking.distance.empty": "Ative a localizacao para gerar o ranking por distancia.",
    "ranking.ready.eyebrow": "Lojas prontas",
    "ranking.ready.title": "Lojas prontas para abrir",
    "ranking.ready.description":
      "Atalho para abrir lojas ja carregadas no mapa e ver o catalogo mais recente de cada uma.",
    "ranking.ready.store": "loja",
    "ranking.ready.empty": "Carregue o mapa para ver lojas prontas para abrir.",
    "ranking.common.address_missing": "Morada ainda nao informada",
    "ranking.price.eyebrow": "Preco",
    "ranking.price.title": "Melhor indice medio de preco",
    "ranking.price.description":
      "Ranking calculado com precos disponiveis, historico e volume de atualizacoes.",
    "ranking.price.index": "indice",
    "ranking.price.average": "Media",
    "ranking.price.meta": "Produtos: {{count}} | atualiz.: {{contributions}}",
    "ranking.price.empty": "Ainda nao ha ranking de preco disponivel.",
  },
};

const BILLING_UI_TRANSLATIONS = {
  "pt-BR": {
    "billing.paywall.badge": "Premium",
    "billing.paywall.title": "Seu trial acabou",
    "billing.paywall.description":
      "Assine para continuar usando comparacao de mercados, listas inteligentes e catalogos em tempo real no PennyPantry.",
    "billing.paywall.cta": "Continuar com assinatura",
    "billing.paywall.activating": "Ativando assinatura...",
    "billing.paywall.logout": "Sair da conta",
    "billing.paywall.refresh": "Atualizar status",
    "billing.paywall.sandbox":
      "Modo sandbox ativo: no desenvolvimento, o botao abaixo ativa a assinatura de teste. Para publicar, conecte Google Play Billing e App Store.",
    "billing.paywall.feature_1":
      "Mercados proximos, busca e catalogos continuam liberados enquanto a assinatura estiver ativa.",
    "billing.paywall.feature_2":
      "O valor usa a moeda local do usuario com base na regiao configurada no app.",
    "billing.plan.label": "Plano mensal PennyPantry",
    "billing.plan.per_month": "/mes",
    "billing.plan.usd_equivalent": "Equivale a {{amount}} por mes.",
    "billing.plan.trial_ended_at": "Trial encerrado em {{date}}.",
    "billing.section.eyebrow": "Assinatura",
    "billing.section.title": "Plano do app",
    "billing.section.description":
      "Todo usuario recebe 14 dias gratis. Depois, o acesso continua com a assinatura mensal na moeda local.",
    "billing.section.status": "Status",
    "billing.section.monthly_price": "Mensalidade",
    "billing.section.country": "Pais e moeda",
    "billing.section.trial_until": "Trial ate {{date}}",
    "billing.section.renews_until": "Ciclo atual ate {{date}}",
    "billing.section.payment_required": "A assinatura precisa ser ativada para continuar.",
    "billing.section.usd_reference": "Base USD: {{value}}",
    "billing.section.days_remaining": "{{count}} dia(s) restantes",
    "billing.section.activate": "Ativar assinatura",
    "billing.section.activating": "Ativando...",
    "billing.section.sandbox": "Sandbox ligado: em dev, a ativacao funciona como teste.",
    "billing.section.production_note": "Em producao, conecte Google Play Billing e App Store.",
    "billing.section.loading": "Carregando status da assinatura...",
    "billing.status.active": "Ativa",
    "billing.status.trial": "Trial",
    "billing.status.expired": "Pagamento pendente",
  },
  en: {
    "billing.paywall.badge": "Premium",
    "billing.paywall.title": "Your trial ended",
    "billing.paywall.description":
      "Subscribe to keep using market comparison, smart lists and live catalogs in PennyPantry.",
    "billing.paywall.cta": "Continue with subscription",
    "billing.paywall.activating": "Activating subscription...",
    "billing.paywall.logout": "Sign out",
    "billing.paywall.refresh": "Refresh status",
    "billing.paywall.sandbox":
      "Sandbox mode is on: during development, the button below activates a test subscription. Before launch, connect Google Play Billing and the App Store.",
    "billing.paywall.feature_1":
      "Nearby markets, search and catalogs stay available while the subscription is active.",
    "billing.paywall.feature_2":
      "Pricing uses the user's local currency based on the region configured in the app.",
    "billing.plan.label": "PennyPantry monthly plan",
    "billing.plan.per_month": "/month",
    "billing.plan.usd_equivalent": "Equivalent to {{amount}} per month.",
    "billing.plan.trial_ended_at": "Trial ended on {{date}}.",
    "billing.section.eyebrow": "Subscription",
    "billing.section.title": "App plan",
    "billing.section.description":
      "Every user gets 14 free days. After that, access continues with a monthly subscription in the local currency.",
    "billing.section.status": "Status",
    "billing.section.monthly_price": "Monthly price",
    "billing.section.country": "Country and currency",
    "billing.section.trial_until": "Trial until {{date}}",
    "billing.section.renews_until": "Current cycle until {{date}}",
    "billing.section.payment_required": "The subscription must be activated to continue.",
    "billing.section.usd_reference": "USD base: {{value}}",
    "billing.section.days_remaining": "{{count}} day(s) remaining",
    "billing.section.activate": "Activate subscription",
    "billing.section.activating": "Activating...",
    "billing.section.sandbox": "Sandbox on: in dev, activation works as a test.",
    "billing.section.production_note": "In production, connect Google Play Billing and the App Store.",
    "billing.section.loading": "Loading subscription status...",
    "billing.status.active": "Active",
    "billing.status.trial": "Trial",
    "billing.status.expired": "Payment required",
  },
  es: {
    "billing.paywall.badge": "Premium",
    "billing.paywall.title": "Tu prueba termino",
    "billing.paywall.description":
      "Suscribete para seguir usando comparacion de mercados, listas inteligentes y catalogos en tiempo real en PennyPantry.",
    "billing.paywall.cta": "Continuar con suscripcion",
    "billing.paywall.activating": "Activando suscripcion...",
    "billing.paywall.logout": "Salir de la cuenta",
    "billing.paywall.refresh": "Actualizar estado",
    "billing.paywall.sandbox":
      "Modo sandbox activo: en desarrollo, el boton de abajo activa una suscripcion de prueba. Antes de publicar, conecta Google Play Billing y App Store.",
    "billing.paywall.feature_1":
      "Mercados cercanos, busqueda y catalogos siguen disponibles mientras la suscripcion este activa.",
    "billing.paywall.feature_2":
      "El precio usa la moneda local del usuario segun la region configurada en la app.",
    "billing.plan.label": "Plan mensual PennyPantry",
    "billing.plan.per_month": "/mes",
    "billing.plan.usd_equivalent": "Equivale a {{amount}} por mes.",
    "billing.plan.trial_ended_at": "La prueba termino el {{date}}.",
    "billing.section.eyebrow": "Suscripcion",
    "billing.section.title": "Plan de la app",
    "billing.section.description":
      "Cada usuario recibe 14 dias gratis. Despues, el acceso sigue con una suscripcion mensual en la moneda local.",
    "billing.section.status": "Estado",
    "billing.section.monthly_price": "Precio mensual",
    "billing.section.country": "Pais y moneda",
    "billing.section.trial_until": "Prueba hasta {{date}}",
    "billing.section.renews_until": "Ciclo actual hasta {{date}}",
    "billing.section.payment_required": "La suscripcion debe activarse para continuar.",
    "billing.section.usd_reference": "Base USD: {{value}}",
    "billing.section.days_remaining": "{{count}} dia(s) restantes",
    "billing.section.activate": "Activar suscripcion",
    "billing.section.activating": "Activando...",
    "billing.section.sandbox": "Sandbox activo: en desarrollo, la activacion funciona como prueba.",
    "billing.section.production_note": "En produccion, conecta Google Play Billing y App Store.",
    "billing.section.loading": "Cargando estado de la suscripcion...",
    "billing.status.active": "Activa",
    "billing.status.trial": "Prueba",
    "billing.status.expired": "Pago pendiente",
  },
  it: {
    "billing.paywall.badge": "Premium",
    "billing.paywall.title": "La prova e finita",
    "billing.paywall.description":
      "Abbonati per continuare a usare confronto mercati, liste intelligenti e cataloghi in tempo reale in PennyPantry.",
    "billing.paywall.cta": "Continua con abbonamento",
    "billing.paywall.activating": "Attivazione abbonamento...",
    "billing.paywall.logout": "Esci dall'account",
    "billing.paywall.refresh": "Aggiorna stato",
    "billing.paywall.sandbox":
      "Modalita sandbox attiva: in sviluppo il pulsante sotto attiva un abbonamento di test. Prima del lancio, collega Google Play Billing e App Store.",
    "billing.paywall.feature_1":
      "Mercati vicini, ricerca e cataloghi restano disponibili mentre l'abbonamento e attivo.",
    "billing.paywall.feature_2":
      "Il prezzo usa la valuta locale dell'utente in base alla regione configurata nell'app.",
    "billing.plan.label": "Piano mensile PennyPantry",
    "billing.plan.per_month": "/mese",
    "billing.plan.usd_equivalent": "Equivale a {{amount}} al mese.",
    "billing.plan.trial_ended_at": "La prova e terminata il {{date}}.",
    "billing.section.eyebrow": "Abbonamento",
    "billing.section.title": "Piano dell'app",
    "billing.section.description":
      "Ogni utente riceve 14 giorni gratis. Dopo, l'accesso continua con un abbonamento mensile nella valuta locale.",
    "billing.section.status": "Stato",
    "billing.section.monthly_price": "Prezzo mensile",
    "billing.section.country": "Paese e valuta",
    "billing.section.trial_until": "Prova fino a {{date}}",
    "billing.section.renews_until": "Ciclo corrente fino a {{date}}",
    "billing.section.payment_required": "L'abbonamento deve essere attivato per continuare.",
    "billing.section.usd_reference": "Base USD: {{value}}",
    "billing.section.days_remaining": "{{count}} giorno/i rimanenti",
    "billing.section.activate": "Attiva abbonamento",
    "billing.section.activating": "Attivazione...",
    "billing.section.sandbox": "Sandbox attiva: in sviluppo l'attivazione funziona come test.",
    "billing.section.production_note": "In produzione, collega Google Play Billing e App Store.",
    "billing.section.loading": "Caricamento stato abbonamento...",
    "billing.status.active": "Attivo",
    "billing.status.trial": "Prova",
    "billing.status.expired": "Pagamento richiesto",
  },
  fr: {
    "billing.paywall.badge": "Premium",
    "billing.paywall.title": "Votre essai est termine",
    "billing.paywall.description":
      "Abonnez-vous pour continuer a utiliser la comparaison de magasins, les listes intelligentes et les catalogues en temps reel dans PennyPantry.",
    "billing.paywall.cta": "Continuer avec l'abonnement",
    "billing.paywall.activating": "Activation de l'abonnement...",
    "billing.paywall.logout": "Se deconnecter",
    "billing.paywall.refresh": "Actualiser le statut",
    "billing.paywall.sandbox":
      "Mode sandbox actif : en developpement, le bouton ci-dessous active un abonnement de test. Avant le lancement, connectez Google Play Billing et l'App Store.",
    "billing.paywall.feature_1":
      "Magasins proches, recherche et catalogues restent disponibles tant que l'abonnement est actif.",
    "billing.paywall.feature_2":
      "Le prix utilise la devise locale de l'utilisateur selon la region configuree dans l'app.",
    "billing.plan.label": "Abonnement mensuel PennyPantry",
    "billing.plan.per_month": "/mois",
    "billing.plan.usd_equivalent": "Equivalent a {{amount}} par mois.",
    "billing.plan.trial_ended_at": "Essai termine le {{date}}.",
    "billing.section.eyebrow": "Abonnement",
    "billing.section.title": "Forfait de l'app",
    "billing.section.description":
      "Chaque utilisateur recoit 14 jours gratuits. Ensuite, l'acces continue avec un abonnement mensuel dans la devise locale.",
    "billing.section.status": "Statut",
    "billing.section.monthly_price": "Prix mensuel",
    "billing.section.country": "Pays et devise",
    "billing.section.trial_until": "Essai jusqu'au {{date}}",
    "billing.section.renews_until": "Cycle actuel jusqu'au {{date}}",
    "billing.section.payment_required": "L'abonnement doit etre active pour continuer.",
    "billing.section.usd_reference": "Base USD : {{value}}",
    "billing.section.days_remaining": "{{count}} jour(s) restants",
    "billing.section.activate": "Activer l'abonnement",
    "billing.section.activating": "Activation...",
    "billing.section.sandbox": "Sandbox active : en dev, l'activation fonctionne comme test.",
    "billing.section.production_note": "En production, connectez Google Play Billing et l'App Store.",
    "billing.section.loading": "Chargement du statut de l'abonnement...",
    "billing.status.active": "Actif",
    "billing.status.trial": "Essai",
    "billing.status.expired": "Paiement requis",
  },
  de: {
    "billing.paywall.badge": "Premium",
    "billing.paywall.title": "Dein Test ist abgelaufen",
    "billing.paywall.description":
      "Abonniere, um Marktvergleich, smarte Listen und Live-Kataloge in PennyPantry weiter zu nutzen.",
    "billing.paywall.cta": "Mit Abo fortfahren",
    "billing.paywall.activating": "Abo wird aktiviert...",
    "billing.paywall.logout": "Abmelden",
    "billing.paywall.refresh": "Status aktualisieren",
    "billing.paywall.sandbox":
      "Sandbox-Modus aktiv: in der Entwicklung aktiviert die Taste unten ein Testabo. Vor dem Release Google Play Billing und den App Store verbinden.",
    "billing.paywall.feature_1":
      "Nahe Markte, Suche und Kataloge bleiben verfugbar, solange das Abo aktiv ist.",
    "billing.paywall.feature_2":
      "Der Preis nutzt die lokale Wahrung des Nutzers anhand der im App gesetzten Region.",
    "billing.plan.label": "PennyPantry Monatsabo",
    "billing.plan.per_month": "/Monat",
    "billing.plan.usd_equivalent": "Entspricht {{amount}} pro Monat.",
    "billing.plan.trial_ended_at": "Test endete am {{date}}.",
    "billing.section.eyebrow": "Abonnement",
    "billing.section.title": "App-Plan",
    "billing.section.description":
      "Jeder Nutzer erhalt 14 freie Tage. Danach lauft der Zugang uber ein Monatsabo in lokaler Wahrung weiter.",
    "billing.section.status": "Status",
    "billing.section.monthly_price": "Monatspreis",
    "billing.section.country": "Land und Wahrung",
    "billing.section.trial_until": "Test bis {{date}}",
    "billing.section.renews_until": "Aktueller Zyklus bis {{date}}",
    "billing.section.payment_required": "Das Abo muss aktiviert werden, um fortzufahren.",
    "billing.section.usd_reference": "USD-Basis: {{value}}",
    "billing.section.days_remaining": "{{count}} Tag(e) verbleibend",
    "billing.section.activate": "Abo aktivieren",
    "billing.section.activating": "Aktivierung...",
    "billing.section.sandbox": "Sandbox aktiv: in Dev funktioniert die Aktivierung als Test.",
    "billing.section.production_note": "In Produktion Google Play Billing und den App Store verbinden.",
    "billing.section.loading": "Abostatus wird geladen...",
    "billing.status.active": "Aktiv",
    "billing.status.trial": "Test",
    "billing.status.expired": "Zahlung erforderlich",
  },
  "pt-PT": {
    "billing.paywall.badge": "Premium",
    "billing.paywall.title": "O seu trial terminou",
    "billing.paywall.description":
      "Subscreva para continuar a usar comparacao de mercados, listas inteligentes e catalogos em tempo real no PennyPantry.",
    "billing.paywall.cta": "Continuar com subscricao",
    "billing.paywall.activating": "A ativar subscricao...",
    "billing.paywall.logout": "Sair da conta",
    "billing.paywall.refresh": "Atualizar estado",
    "billing.paywall.sandbox":
      "Modo sandbox ativo: em desenvolvimento, o botao abaixo ativa uma subscricao de teste. Antes de publicar, ligue Google Play Billing e App Store.",
    "billing.paywall.feature_1":
      "Mercados proximos, pesquisa e catalogos continuam disponiveis enquanto a subscricao estiver ativa.",
    "billing.paywall.feature_2":
      "O preco usa a moeda local do utilizador com base na regiao configurada na app.",
    "billing.plan.label": "Plano mensal PennyPantry",
    "billing.plan.per_month": "/mes",
    "billing.plan.usd_equivalent": "Equivale a {{amount}} por mes.",
    "billing.plan.trial_ended_at": "Trial terminado em {{date}}.",
    "billing.section.eyebrow": "Subscricao",
    "billing.section.title": "Plano da app",
    "billing.section.description":
      "Cada utilizador recebe 14 dias gratis. Depois, o acesso continua com uma subscricao mensal na moeda local.",
    "billing.section.status": "Estado",
    "billing.section.monthly_price": "Preco mensal",
    "billing.section.country": "Pais e moeda",
    "billing.section.trial_until": "Trial ate {{date}}",
    "billing.section.renews_until": "Ciclo atual ate {{date}}",
    "billing.section.payment_required": "A subscricao precisa de ser ativada para continuar.",
    "billing.section.usd_reference": "Base USD: {{value}}",
    "billing.section.days_remaining": "{{count}} dia(s) restantes",
    "billing.section.activate": "Ativar subscricao",
    "billing.section.activating": "A ativar...",
    "billing.section.sandbox": "Sandbox ligado: em dev, a ativacao funciona como teste.",
    "billing.section.production_note": "Em producao, ligue Google Play Billing e App Store.",
    "billing.section.loading": "A carregar estado da subscricao...",
    "billing.status.active": "Ativa",
    "billing.status.trial": "Trial",
    "billing.status.expired": "Pagamento pendente",
  },
};

Object.entries(PRODUCT_UI_TRANSLATIONS).forEach(([language, entries]) => {
  EXTRA_TRANSLATIONS[language] = {
    ...(EXTRA_TRANSLATIONS[language] || {}),
    ...entries,
  };
});

Object.entries(BILLING_UI_TRANSLATIONS).forEach(([language, entries]) => {
  EXTRA_TRANSLATIONS[language] = {
    ...(EXTRA_TRANSLATIONS[language] || {}),
    ...entries,
  };
});

Object.entries(STATUS_TRANSLATIONS).forEach(([language, entries]) => {
  EXTRA_TRANSLATIONS[language] = {
    ...(EXTRA_TRANSLATIONS[language] || {}),
    ...entries,
  };
});

Object.entries(EXTRA_TRANSLATIONS).forEach(([language, entries]) => {
  TRANSLATIONS[language] = {
    ...(TRANSLATIONS[language] || {}),
    ...entries,
  };
});

Object.entries(UI_COPY_TRANSLATIONS).forEach(([language, entries]) => {
  TRANSLATIONS[language] = {
    ...(TRANSLATIONS[language] || {}),
    ...entries,
  };
});

function normalizeLanguage(language) {
  return SUPPORTED_LANGUAGE_CODES.has(language) ? language : DEFAULT_LANGUAGE;
}

export function createTranslator(language) {
  const activeLanguage = normalizeLanguage(language);
  return (key, fallback = "", params = {}) => {
    const translatedByKey = TRANSLATIONS[activeLanguage]?.[key];

    if (translatedByKey) {
      return translateFallbackText(activeLanguage, translatedByKey, params);
    }

    const sourceText =
      TRANSLATIONS.en?.[key] ||
      fallback ||
      TRANSLATIONS[DEFAULT_LANGUAGE]?.[key] ||
      key;

    return translateFallbackText(activeLanguage, sourceText, params);
  };
}

export function translateRuntimeText(language, text, params = {}) {
  return translateFallbackText(normalizeLanguage(language), text, params);
}

export function getLocaleForLanguage(language) {
  return LANGUAGE_LOCALES[normalizeLanguage(language)] || LANGUAGE_LOCALES[DEFAULT_LANGUAGE];
}

export function getRuntimeLanguage() {
  if (typeof window === "undefined") {
    return DEFAULT_LANGUAGE;
  }

  return normalizeLanguage(
    window.localStorage.getItem(UI_LANGUAGE_STORAGE_KEY) ||
      window.localStorage.getItem(LEGACY_UI_LANGUAGE_STORAGE_KEY) ||
      DEFAULT_LANGUAGE
  );
}
